import { Link } from 'react-router-dom';

export default function AhrefsAlternativePage() {
  return (
    <div style={{ background: 'white', minHeight: '100vh' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '40px 24px' }}>
        <div style={{ textAlign: 'center', maxWidth: 800, margin: '0 auto 40px' }}>
          <div style={{ display: 'inline-flex', background: '#E8F5E9', color: '#2E7D32', fontSize: 11, fontWeight: 700, padding: '4px 12px', borderRadius: 99, marginBottom: 16 }}>AHREFS ALTERNATIVE</div>
          <h1 style={{ fontSize: 48, fontWeight: 800, lineHeight: 1.1, letterSpacing: '-0.03em', marginBottom: 16 }}>A Lower-Cost Alternative<br/><span style={{ color: '#2E7D32' }}>to Ahrefs</span></h1>
          <p style={{ fontSize: 18, color: '#6B7280', lineHeight: 1.5, marginBottom: 24 }}>Backlink data, keyword research, and site audits from the same underlying data provider (DataForSEO), at a lower monthly price than Ahrefs.</p>
          <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
            <Link to="/backlinks/overview" className="btn btn-lg" style={{ background: '#2E7D32', color: 'white', height: 48, padding: '0 24px' }}>Try the Backlink Checker Free →</Link>
            <Link to="/pricing" className="btn btn-lg btn-white" style={{ height: 48 }}>Compare Pricing</Link>
          </div>
        </div>

        <div style={{ maxWidth: 900, margin: '0 auto 40px', background: '#FAFBFC', border: '1px solid #E5E7EB', borderRadius: 12, overflow: 'hidden' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 0, textAlign: 'center', fontSize: 13 }}>
            <div style={{ padding: 16, fontWeight: 700, background: '#F3F4F6' }}>Feature</div>
            <div style={{ padding: 16, fontWeight: 800, background: '#E8F5E9', color: '#2E7D32' }}>Sungresh $59/mo</div>
            <div style={{ padding: 16, fontWeight: 700, background: '#F3F4F6' }}>Ahrefs $99/mo</div>
            {[
              ['Backlink data source', 'DataForSEO', 'Ahrefs own index'],
              ['Keyword ideas per search', '200+', '~1,000'],
              ['Site audit', 'Included', 'Included'],
              ['API access', 'Included', 'Enterprise plan only'],
            ].map(([feat, sun, ah], i) => (
              <div style={{ display: 'contents' }} key={i}>
                <div style={{ padding: '12px 16px', borderBottom: '1px solid #F3F4F6', textAlign: 'left', fontWeight: 600 }}>{feat}</div>
                <div style={{ padding: '12px 16px', borderBottom: '1px solid #F3F4F6', background: '#F1F8E9', fontWeight: 700 }}>{sun}</div>
                <div style={{ padding: '12px 16px', borderBottom: '1px solid #F3F4F6', color: '#6B7280' }}>{ah}</div>
              </div>
            ))}
          </div>
        </div>
        <p style={{ maxWidth: 900, margin: '-24px auto 40px', fontSize: 12, color: '#9CA3AF', textAlign: 'center' }}>Ahrefs pricing and feature details as publicly listed; check ahrefs.com for current numbers, as pricing changes over time.</p>

        <div style={{ maxWidth: 800, margin: '0 auto', background: '#111', color: 'white', borderRadius: 12, padding: 24, textAlign: 'center' }}>
          <div style={{ fontWeight: 800, fontSize: 20, marginBottom: 8 }}>Same underlying data, lower monthly cost</div>
          <div style={{ fontSize: 13, color: '#9CA3AF', marginBottom: 16 }}>Backlinks, keywords, and site audit in one plan</div>
          <Link to="/" className="btn" style={{ background: '#2E7D32', color: 'white' }}>Start Free →</Link>
        </div>
      </div>
    </div>
  );
}
